import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=6605cff8&scoped=true"
import script from "./DeviceDetail.vue?vue&type=script&lang=ts"
export * from "./DeviceDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605cff8",
  null
  
)

export default component.exports